export default "__VITE_ASSET__eb945a1d__"